
import { useState } from 'react'
import useWindowSize from '../../../../../../../utils/hooks/useWindowSize'
import ReactDataTable from '../../../../../../components/_shared/Table/ReactDataTable'
import ReactExpandableTable from '../../../../../../components/_shared/Table/ReactExpandableTable'
import {
    deviceHighScoringColumn,
    mobileDeviceHighScoringColumn,
} from './devicesHighScoringColumn'
import ExpandableDevicesHighScoringTable from './ExpandableDevicesHighScoringTable'
import ReportFooter from '../../../reports/Pages/ReportsFooter/ReportFooter'

const DeviceHighScoringTable = ({
    data,
    isLoading,
    tableOptions,
    totaldata,
    pageCount,
    handlePageClick,
    handleRowsPerPage,
    handleColumnSort,
    downloadPDF,
    downloadExcel,
    reportData,
    reportCode,
    reportTableData,
    generatePDFFunction,
    excelMode = 'api', // default
}) => {
    const size = useWindowSize();
    const [currentRow, setCurrentRow] = useState(null);

    if (size.width < 768) {
        return (
            <>
            <h1 className="mb-4">Devices High Scoring</h1>
                <ReactExpandableTable
                    isLoading={isLoading}
                    data={data}
                    mobileColumns={mobileDeviceHighScoringColumn}
                    pageCount={pageCount}
                    activePage={tableOptions?.activePage}
                    rowPerPages={tableOptions?.rowPerPages}
                    removePagination={false}
                    totaldata={totaldata}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    handleRowsPerPage={handleRowsPerPage}
                    handlePageClick={handlePageClick}
                    expandableComponent={ExpandableDevicesHighScoringTable}
                    handleColumnSort={handleColumnSort}
                />
                <ReportFooter
                    BackText="Back"
                    PdfText="PDF"
                    MailText="Mail"
                    ExcelText="Excel"
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={reportTableData}
                    generatePDFFunction={generatePDFFunction}
                    excelMode={excelMode}
                />
            </>
        );
    }

    return (
        <>
         <h1 className="mb-4">Devices High Scoring</h1>
            <ReactDataTable
                isLoading={isLoading}
                data={data}
                columns={deviceHighScoringColumn}
                totaldata={totaldata}
                pageCount={pageCount}
                activePage={tableOptions?.activePage}
                rowPerPages={tableOptions?.rowPerPages}
                removePagination={false}
                handleRowsPerPage={handleRowsPerPage}
                handlePageClick={handlePageClick}
                handleColumnSort={handleColumnSort}
            />
            <ReportFooter
                BackText="Back"
                PdfText="PDF"
                MailText="Mail"
                ExcelText="Excel"
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                reportData={reportData}
                reportCode={reportCode}
                reportTableData={reportTableData}
                generatePDFFunction={generatePDFFunction}
                excelMode={excelMode}
            />
        </>
    );
};

export default DeviceHighScoringTable;